import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICargoResponse } from '../models/models'

export class GetSuggestAIApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'basket2/getSuggestProductAI',
      requesterInfo,
    })
  }

  public async getSuggestList(): Promise<any> {
    return await this.getAsync<any>()
  }
}
